
import { useParams } from "react-router-dom";
import { Dynamic } from "../../../../controllers/conductor";
import { getController } from "../../../../controllers/getter";
import { SameDayReportsController } from "../../../../controllers/reports/Sameday";
import { getCurrentMonth } from "../../../../misc/date";
import { AlertDrawer } from "../../../sections/sidebar/AlertDrawer";
import { Button, IconButton } from "../../../widgets/buttons";
import { MonthYearSelector, YearSelector } from "../../../widgets/date_selector";
import { LocationSelector } from "../../../widgets/form";
import { LoadingAnimation } from "../../../widgets/loading";
import { Blocker } from "../../../widgets/misc";
import { ScrollingTable } from "../../../widgets/table";
import { MainWindow } from "../../MainWindow";

import "../../../../styles/reports.css";
import Client from "../../../../Client";

export function SameDayReports() {

    const ref = {    
        section1: {
            year: getCurrentMonth(false).year - 1
        },
        section2: {
            ...getCurrentMonth(false),
            lgu: "1", province: "1"
        },
        attractions: {
            year: getCurrentMonth(false).year - 1,
            lgu: "1", province: "1"
        }
    };

    const controller = getController(SameDayReportsController, { ref });

    const { notifiers, status } = controller;
    
    return (<MainWindow currentTab="reports" subtab="sameday">
        <Dynamic conductor={[ notifiers.ready, notifiers.unauthorized ]} child={()=>
            status.unauthorized ? <Unauthorized /> : status.ready ? <Main controller={controller} /> : <LoadingWindow />
        } />
    </MainWindow>);
}

function Unauthorized() {
    return <div>Unauthorized</div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}


function Main({ controller }) {
    return <div className="form-main reports">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} />
        <MainSection controller={controller} />
        <Footer controller={controller} />
    </div>;
}


function Header({ controller }) {
    const { notifiers } = controller;

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);

    return <Dynamic conductor={notifiers.reloaded} child={()=>{

        return <header>
            <div>
                <h2>Sameday Reports</h2>
            </div>
        </header>;
    }} />;
}

function MainSection({ controller }) {
    const role = Client.account.role;

    return <main className="main reports">
        { ["admin", "reviewer"].includes(role) ? <Section1 controller={controller} /> : "" }
        { ["admin"].includes(role) ? <hr /> : "" }

        { ["admin", "reviewer", "province", "lgu"].includes(role) ? <Section2 controller={controller} /> : "" }
        { ["admin", "reviewer", "province", "lgu"].includes(role) ? <hr /> : "" }
        
        { ["admin", "reviewer", "province", "lgu"].includes(role) ? <Section3 controller={controller} /> : "" }
        { ["admin", "reviewer", "province", "lgu"].includes(role) ? <hr /> : "" }

    </main>;
        
    
}

function Section1({ controller }) {
    const { year } = controller.reference.section1;
    let date = { year };
    const { report1 } = controller.notifiers.downloading;

    return <section className="reports-section">
        <header><h4>Annual Regional Report</h4></header>
        <YearSelector year={year} onChange={d => date = d} />
        <Dynamic conductor={report1} child={()=> {
            const downloading = report1.get();
            return <Button icon="download" inProgress={downloading} color="green" onClick={() => controller.downloadReport1(date)}>
                { downloading ? "DOWNLOADING..." : "DOWNLOAD REPORT"}
            </Button>
        }} />
    </section>
}

function Section2({ controller }) {
    const { report2 } = controller.notifiers.downloading;
    const { month, year, province, lgu } = controller.reference.section2;
    const { lguFixed, provinceFixed } = controller.reference.global;
    let date = { month, year };
    let locationValues = { province, lgu };

    return <section className="reports-section">
        <header><h4>Monthly Municipality/City Report</h4></header>
        <MonthYearSelector month={month} year={year} onChange={d => date = d} />
        <LocationSelector lguFixed={lguFixed} provinceFixed={provinceFixed} values={{ lgu, province }} collection={controller.collection} onChange={v => locationValues = v} />
        <Dynamic conductor={report2} child={()=> {
            const downloading = report2.get();
            return <Button icon="download" color="green" inProgress={downloading} onClick={() => controller.downloadReport2({ ...locationValues, ...date })}>
                { downloading ? "DOWNLOADING..." : "DOWNLOAD REPORT" }
            </Button>
        }} />
    </section>
}

function Section3({ controller }) {
    const columns = [
        { title: "NAME", width: "40%" },
        { title: "CATEGORY", width: "20%" },
        { title: "", width: "40%" }
    ];




    const { notifiers, status } = controller;
    const { lgu, province, year } = controller.reference.attractions;
    const { lguFixed, provinceFixed } = controller.reference.global;
    let locationValues = { lgu, province };
    let date = { year };

    return <section className="reports-section attractions">
        <header>
            <div>
                <h4>Annual Tourist Attraction Report</h4>
            </div>
            <div>
                <YearSelector year={year} onChange={d => date.year = d.year} />
                <LocationSelector lguFixed={lguFixed} provinceFixed={provinceFixed} values={{ lgu, province }} collection={controller.collection} onChange={v => locationValues = v} />
                <Button color="blue" icon="filter" onClick={()=>controller.changeAttractionsLocation(locationValues.province, locationValues.lgu)}>FILTER</Button>
            </div>
        </header>
        <main>
            <Dynamic conductor={notifiers.attractions.loaded} child={()=>{
                const data = controller.data.attractions;

                if(data.length === 0) return <center>No tourist attractions yet.</center>;

                const rows = data.map((attraction, ai) => {
                    const { name, category } = attraction;

                    return [
                        name,
                        category,
                        <div style={{opacity: 0.7}}>
                            <Dynamic conductor={notifiers.downloading.report3} child={()=> {
                                const isDownloading = notifiers.downloading.report3.get() === attraction.id;
                                return <Button icon="download" inProgress={isDownloading} onClick={()=>controller.downloadReport3(date.year, attraction.id)}>
                                    {isDownloading ? "DOWNLOADING..." : "DOWNLOAD ANNUAL REPORT"}</Button>
                            }} />
                                
                        </div>
                    ];
                });

                return <ScrollingTable columns={columns} rows={rows} />;
            }} />
            <Dynamic conductor={notifiers.attractions.loading} child={()=>
                <Blocker active={status.attractions.loading}><center><LoadingAnimation />Loading data...</center></Blocker>
            } />
        </main>
    </section> 
}


function Footer() {
    return <div />
}